module.exports = __webpack_public_path__ + "img/enjoy-safety.ccb7bf5b.jpg";